import React from "react";

/**
 * Two-pane body for a page whose header is fixed at the top: a rail on the
 * left (athlete list) and a pane on the right (overview), both filling the
 * rest of the window. The page itself does not scroll — the rail scrolls
 * inside its card and the pane scrolls as a whole — so both bottom edges
 * meet the window bottom at any zoom or roster size.
 *
 * Usage: wrap the page in <PageFrame> (fixed height column), put the hero
 * and tabs first, then <PaneFrame rail={...}>pane content</PaneFrame>.
 *
 * Below the lg breakpoint the rail stacks above the pane at a capped height
 * so small windows still work.
 */
export const PageFrame = ({ children, className = "" }) => (
  <div
    className={`flex h-[calc(100vh-72px)] min-h-0 flex-col bg-[#F8F9FA] ${className}`}
  >
    {children}
  </div>
);

const PaneFrame = ({ rail, children }) => (
  <div className="mx-auto flex min-h-0 w-full max-w-[1440px] flex-1 flex-col gap-4 px-6 pb-6 pt-4 lg:flex-row">
    <aside className="max-lg:max-h-[40vh] flex min-h-0 flex-none flex-col lg:w-[380px] xl:w-[440px]">
      {rail}
    </aside>
    <section className="flex min-h-0 min-w-0 flex-1 flex-col gap-4 overflow-y-auto">
      {children}
    </section>
  </div>
);

export default PaneFrame;
